import { IMcBimMongo } from "@mctypes/mcbimMono.types";
import React from "react";
import { useLocation } from "react-router-dom";
import { MCLoader } from "../../../../components";
import MCBimOverview from "../../../../components/MCBimOverview/MCBimOverview";
import { useGetProjectQuery } from "../../../projectRTK";
import { getProjectIdFromUrl } from "../../../utils";
import { doGetMcBimProjectInfo } from "./McBimMongoAPI";

const McBimOverviewPage: React.FC = () => {
  const [projectInfo, setProjectInfo] = React.useState<IMcBimMongo.ProjectInfo | null>(null);

  const location = useLocation();
  const projectId = getProjectIdFromUrl(location.pathname);

  const { data: project } = useGetProjectQuery(projectId);
  React.useEffect(() => {
    init();
  }, []);

  const init = async () => {
    const _projectInfo = await doGetMcBimProjectInfo(project._id);
    setProjectInfo(_projectInfo);
  };

  return (
    <div>
      {projectInfo != null ? (
        <MCBimOverview data={projectInfo} projectNo={project.maconomy.projectNo.toString()} />
      ) : (
        <MCLoader loading />
      )}
    </div>
  );
};

export default McBimOverviewPage;
